import { gameStorage } from 'services/ElementsStorageService'
import { ModuleSettingsService } from 'services/ModuleSettingsService'
import { signal } from 'services/SignalsService'
import { debug } from 'settings/custom/build'
import { assets } from 'utils/AssetParser'
import { SpineUtils } from 'utils/Spine-Utils'
import { utils } from 'utils/Utils'

export default class SpineInclude {
  _config = null

  constructor(config) {
    this._config        = config
    debug ? this._createGui() : ''
    this._createProps(config)
    this._createInclude()
  }

  _createGui() {
    this._dat = game.gui
  }

  _createGUIprops(x, y, scale) {
    const params = { x, y, scale }
    this._gui = this._dat.include.addFolder(this._name)
    this._gui.add(params, 'x', -1000, 1000, 10).onChange((p) => {
      this._include.x = p
    })
    this._gui.add(params, 'y', -1000, 1000, 10).onChange((p) => {
      this._include.y = p
    })
    this._gui.add(params, 'scale', -10, 10, 0.1).onChange((p) => {
      this._include.scale.set(p)
    })
  }
  _createProps(config) {
    this._spine              = config.spine
    this._type               = config.type
    this._slot               = config.slot
    this._name               = config.name
    this._include            = null
  }

  get include(){
    return this._include
  }
  _createInclude(){
    switch(this._type){
      case 'sprite':
        this.addSpriteInclude()
        break
      case 'obj':
        this.addGameObject()
        break
      case 'entity':
        this.addEntity()
        break
      case 'cascade':
        signal.on('STATE:IN:FS-ADD', this.addQuantityOfFreeSpins.bind(this))
        break
      default:
        throw new Error(`SpineInclude undefined type for ${this._name}`)
    }
  }

  addQuantityOfFreeSpins(){
    this.removeFirstChildren()
    ModuleSettingsService.init()
    const FreeSpinsQuantity = game.models.FreespinModel.get().all
    let spriteName = FreeSpinsQuantity ? `${FreeSpinsQuantity}fs` : '7fs'

    let spritePosition = ModuleSettingsService.getConfig(spriteName)
    let sprite = utils.createSprite(spriteName)

    if(spritePosition) {
      sprite.x = spritePosition.x
      sprite.y = spritePosition.y
      sprite.scale.x = spritePosition.scale
    }
    SpineUtils.replaceSprite(this._spine, this._slot, sprite)
  }

  removeFirstChildren() {
    if(SpineUtils.getSprite(this._spine, this._slot).children[0]){
      SpineUtils.getSprite(this._spine, this._slot).removeChildAt(0)
    }
  }

  addSpriteInclude(){
    ModuleSettingsService.init()
    let spritePosition = ModuleSettingsService.getConfig(this._name)

    const sprite = this._include =  utils.createSprite(this._name)
    if(spritePosition) {
      sprite.x = spritePosition.x
      sprite.y = spritePosition.y
      sprite.scale.x = spritePosition.scale
    }

    SpineUtils.replaceSprite(this._spine, this._slot, sprite)
    debug ? this._createGUIprops(sprite.x, sprite.y, sprite.scale.x) : ''
  }

  addGameObject(){
    const gameObj = this._include  = gameStorage.get(this._name)
    const data = gameObj.data
    SpineUtils.addObj(this._spine, this._slot, gameObj)

    signal.once('STATE:OUT:INIT', () => {
      gameObj.x = data.orientation ? data.orientation.land.x : 0
      gameObj.y = data.orientation ? data.orientation.land.y : 0
      gameObj.scale.set(data.scale ? data.scale : 1)

      if(data.text){
        gameObj.text.anchor.set(0.5)
      }
      debug ?  this._createGUIprops(gameObj.x, gameObj.y, data.scale || 1) : ''
    })
  }

  addEntity(){
    const entity =   this._include  = assets.component.entity[this._name]
    const data = entity.data
    if(!data) {
      throw new Error(`Entity include miss data in entity ${this._name}`)
    }
    SpineUtils.addSpine(this._spine, this._slot, entity)
    signal.once('STATE:OUT:INIT', () => {
      entity.x = data.x || 0
      entity.y = data.y || 0
      entity.scale.set(data.scale || 1)
      debug ?   this._createGUIprops(entity.x, entity.y, data.scale || 1) : ''
    })
  }

}
